import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import WinningPopup from "./components/WinningPopup";
import ScrollToTop from "./components/ScrollToTop";
import SeoInjector from "./components/SeoInjector";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import CricketId from "./pages/CricketId";
import About from "./pages/About";
import HowToPlay from "./pages/HowToPlay";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import DynamicPage from "./pages/DynamicPage";
import Admin from "./pages/Admin";

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <>
      <Navbar />
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cricket-id" element={<CricketId />} />
        <Route path="/how-to-play" element={<HowToPlay />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/:slug" element={<DynamicPage />} />
      </Routes>
      <Footer />
      <FloatingButtons />
      <WinningPopup />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SeoInjector />
          <Layout />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
